import {
  demoEngagementSuccessModalBody,
  demoEngagementSuccessModalHeader,
  demoEngagementSuccessModalSubHeader,
  demoEngagementSuccessModalBody2
} from "../../util/constants";
import { Button } from "../CommonUIComponents/Button/Button";
import { Modal } from "../CommonUIComponents/Modal/Modal";
import "./DemoEngagementSuccessModal.scss";

function ModalBody() {
  return (
    <>
    <p>{demoEngagementSuccessModalSubHeader}</p>
    <p className="demo-endagement-delete-modal-body">{demoEngagementSuccessModalBody}</p>
    <p>{demoEngagementSuccessModalBody2}</p>
    </>
  );
}

function ModalFooter({ handleCancelClick, onConfirm }) {
  return (
    <div className="demo-endagement-delete-modal-footer">
      <Button onClick={onConfirm} variant="primary">
        {"OK"}
      </Button>
    </div>
  );
}

export function DemoEngagementSuccessModal({
  isModalVisible,
  onClose,
  onConfirm,
}) {
  return (
    <Modal
      show={isModalVisible}
      onClose={onClose}
      header={
        <div className="file-version-history-modal-header">
          <span>{demoEngagementSuccessModalHeader}</span>
        </div>
      }
      body={<ModalBody />}
      footer={<ModalFooter handleCancelClick={onClose} onConfirm={onConfirm} />}
    />
  );
}
